'use client';
import { appConfig } from '../../utils/appConfig';
import { useNavigationContext } from './index';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

export interface NavDropdownWrapperProps {
  children: React.ReactNode;
  open: boolean;
  isDropdown: boolean;
  id: string;
  onTransitionEnd?: (e: React.TransitionEvent<HTMLDivElement>) => void;
}

 
const NavDropdownWrapper = ({
  children,
  open,
  isDropdown,
  id,
  onTransitionEnd,
}: NavDropdownWrapperProps) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { setHeight, setOffset } = useNavigationContext();

  React.useEffect(() => {
    if (open && isDropdown) {
      setHeight(ref.current?.getBoundingClientRect().height);
    }
    if (!isDropdown) {
      setOffset(open ? ref.current?.getBoundingClientRect().height : 0);
    }
  }, [open, isDropdown, setHeight, setOffset]);

  return (
    <div
      id={id}
      ref={ref}
      className={classNames(
        'flex justify-center absolute top-full left-0 right-0 border-t border-warm-300 -z-10 gap-8 transition-[opacity,transform]',
        appConfig.isMeater && 'bg-neutral-100',
        open
          ? 'opacity-100 delay-200 duration-300'
          : 'pointer-events-none invisible opacity-0 delay-0 duration-200',
      )}
      onTransitionEnd={onTransitionEnd}
      role="region"
    >
      {children}
    </div>
  );
};

export default NavDropdownWrapper;
